import InfoPanel from './InfoPanel';

export default InfoPanel;
